<template>
  <div style="background-color: #fff">
  <div style="margin: 20px ;font-size: 18px; color: #1890ff; text-align: center">
    <span>整机编号:</span>
    <a-input style="margin: 0px 10px;width: 150px" type="text" v-model="machineId"></a-input>
    <span>公司名称:</span>
    <a-input style="margin: 0px 10px;width: 150px" type="text" v-model="companyName"></a-input>
    <span>销售员:</span>
    <a-input style="margin: 0px 10px;width: 150px" type="text" v-model="salesman"></a-input>
    <span>服务员:</span>
    <a-input style="margin: 0px 10px;width: 150px" type="text" v-model="serviceName"></a-input>
    <span>剩余天数:</span>
    <a-input style="margin: 0px 10px;width: 150px" type="text" v-model="leaveDays"></a-input>
    <a-select default-value="0" style="width: 120px" @change="handleChange">
      <a-select-option value="0">
        全部
      </a-select-option>
      <a-select-option value="1">
        云管控
      </a-select-option>
      <a-select-option value="2">
        非云管控
      </a-select-option>
    </a-select>
    <a-button
      type="primary"
      icon="search"
      style="width: 90px; margin-left: 15px; text-align:center"
      @click="search"
    >查找</a-button>
    <a-button
      type="primary"
      style="width: 90px; margin-left: 20px"
      @click="exportList"
    >导出</a-button>
  </div>
  <a-table 
  :columns="maintainColumns" 
  :data-source="maintainList" 
  :pagination="pagination"
  :row-key="record => record.machineId"
  :loading="loading"
  @change="handleTableChange"
  >
    <template slot="companyName" slot-scope="text, record">
      <a v-if="record.remark !== '云管控'" href="javascript:void(0)" @click="goRoute(record.companyName)" type="link" :title="text.length > 5 ? text : null">{{ text }}</a>
      <span v-else :title="text.length > 5 ? text : null">{{text}}</span>
    </template>
  </a-table>
</div>
</template>

<script>
import crmApi from '@/api/crmreport'
import { maintainColumns } from './data'
export default {
  name: 'customerMaintain',
  data () {
    return {
      maintainColumns,
      maintainList: [],
      pagination: {
        pageSize: 500,
        current: 1,
        total: 0
      },
      machineId: '',
      companyName: '',
      salesman: '',
      serviceName: '',
      leaveDays: '',
      loading: false,
      selectValue: 0
    }
  },
  created () {
    // if (this.$store.state.maintainList) {
    //   this.maintainList = this.$store.state.maintainList
    //   this.$store.commit('setMaintainList', [])
    // }
  },
  methods: {
    formatDate (timeStamp) {
      const date = new Date(timeStamp)
      const Y = date.getFullYear()
      const M = (date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : date.getMonth() + 1
      const D = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
      return (Y + '-' + M + '-' + D)
    },
    handleChange (value) {
      this.pagination.current = 1
      this.selectValue = value
    },
    goRoute (companyName) {
      // this.$store.commit('setMaintainList', this.maintainList)
      this.$router.push({ path: '/customeService', query: { companyName } })
    },
    async search () {
      this.loading = true
      const params = {
        machineId: this.machineId,
        companyName: this.companyName,
        salesman: this.salesman,
        serviceName: this.serviceName,
        leaveDays: +this.leaveDays
      }
      try {
        const maintainList = await crmApi.getMaintainList(this.pagination.current, this.pagination.pageSize, params, this.selectValue)
        this.maintainList = maintainList.records
      } catch {
      }
      maintainList.records.forEach(record => {
        const date = new Date().getTime()
        record.maintainTime = this.formatDate(date + record.leaveDays * 24 * 3600 * 1000)
      })
      this.pagination.total = maintainList.total
      this.loading = false
    },
    async exportList () {
      try {
        const res = await crmApi.exportMaintainList(
          {
            machineId: this.machineId,
            companyName: this.companyName,
            salesman: this.salesman,
            serviceName: this.serviceName,
            leaveDays: +this.leaveDays
          },
          this.selectValue
        )
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        const timestamp = new Date().getTime()
        link.download = timestamp + '.xls'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
        this.$message.success(this.$t('messages.es'), 1)
      } catch {
        this.$message.error('请求失败')
      }
    },
    async handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.search()
    }
  }
}
</script>

<style lang="less" scoped>
.ant-modal-body span {
  display: inline-block;
  width: 30%;
}
.ant-modal-body input {
  outline: none;
  border: 1px solid #ccc;
  width: 70%;
}
.ant-modal-body input.exceptMaintainDate,
.ant-modal-body input.exceptMaintainDate {
  width: 30%;
}
.ant-modal-body input.ant-calendar-picker-input ::placeholder {
  color: red;
}
.ant-popover-inner-content {
  width: 80px
}
/deep/ .ant-table-tbody .ant-table-row:nth-child(2n) {
  background: rgb(240, 240, 241)
}
</style>
